import { connect } from 'react-redux';
import { push, replace } from 'redux-little-router';
import { routeMap } from 'router';

import EmailConfirmation from '../components/EmailConfirmation/index';
import { setData } from '../redux/incomingData/actions';

@connect(
  function ({ app: { incomingData }, router }) {
    return { incomingData, router };
  },
  function (dispatch) {
    return {
      updateIncomingData: (data) => dispatch(setData(data)),
      goToHome: (currentRoute) => {
        const routerMethod = currentRoute !== routeMap.route ? push : replace;
        dispatch(routerMethod(routeMap.home));
      },
    };
  },
)
export default class EmailConfirmationContainer extends EmailConfirmation {}
